import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['WHEEL'],
    small: ['WHEEL', 'GET'],
}

export const TextHeaderEn = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="SPIN THE WHEEL AND GET FREESPINS"
            highlights={[{ word: 'FREESPINS' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
